import React from "react";
import { skills } from "../../data/SiteData";
function Clients(props) {
  return (
    <section id="clients" class="clients">
      <div class="container" data-aos="zoom-in">
        <div class="row d-flex align-items-center">
          {skills.map((item) => {
            return (
              <div class="col-lg-2 col-md-4 col-6">
                <img src={item.image} class="img-fluid" alt="" />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default Clients;
